import { FC, useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";
import type { CustomHeaderProps } from "ag-grid-react";

export const CommitmentIdentifierCellHeader: FC<CustomHeaderProps> = (
  props,
) => {
  const [count, setCount] = useState(props.api.getDisplayedRowCount() ?? 0);

  const title = props.innerHeaderComponentParams?.title;
  useEffect(() => {
    props.api.addEventListener("firstDataRendered", () => {
      setCount(props.api.getDisplayedRowCount());
    });
  }, [props.api]);

  return (
    <Stack>
      <Typography variant="body2" fontWeight="medium">
        {title}
      </Typography>
      <Typography
        fontSize={10}
        color="text.disabled"
        fontWeight={500}
        textAlign="start"
      >
        {count}
      </Typography>
    </Stack>
  );
};
